<script>
import Label from '@/components(new)/UI/Forms/Label/Label.vue'
import AppDisplay from '@/components/AppDisplay.vue'
import { opcoesSimNaoNaoSei, opcoesDestinacaoUsoImovel } from '@/libs/constants/praticas/opcoesSelects'

export default {
  components: {
    Label,
    AppDisplay
  },
  props: {
    usoDoSolo: {
      type: Object
    }
  },
  methods: {
    formataPossuiReservaLegal (value) {
      if (!value) return ''
      return opcoesSimNaoNaoSei.find(opcao => opcao.id === value)?.nome
    },
    formataDestinacaoDoImovel (values) {
      if (!values || !values.length) return ''
      const opcoesFormatadas = values.map(value => opcoesDestinacaoUsoImovel.find(opcao => opcao.id === value)?.nome)
      return opcoesFormatadas.join(', ')
    },
    formataEmpresas (values) {
      if (!values || !values.length) {
        if (this.usoDoSolo.outrasEmpresasFornecedoras) {
          values = [{id: 0, nomeFantasiaRazaoSocial: this.usoDoSolo.outrasEmpresasFornecedoras}]
        }
      } else {
        if (this.usoDoSolo.outrasEmpresasFornecedoras) {
          values = [...values, {id: 0, nomeFantasiaRazaoSocial: this.usoDoSolo.outrasEmpresasFornecedoras}]
        }
      }
      return values.map(empresa => empresa.nomeFantasiaRazaoSocial)?.join(', ')
    }
  }
}

</script>

<template>
  <div>
    <div>
      <span class="title-uso-do-solo">Dados do uso do solo</span>
      <hr />
    </div>
    <el-col :span="12">
      <app-display label="Possui reserva legal?" :content="formataPossuiReservaLegal(usoDoSolo.possuiReservaLegal)" />
      <app-display label="Destinação do imóvel:" :content="formataDestinacaoDoImovel(usoDoSolo.destinacoesImovel)" />
      <app-display label="Destinação da produção:" :content="usoDoSolo.destinacaoProducao" />
    </el-col>
    <el-col :span="12">
      <app-display label="Fornecedor de alguma empresa:" :content="usoDoSolo.hasFornecedoras ? 'Sim' : 'Não'" />
      <app-display  v-if="usoDoSolo.hasFornecedoras" label="Empresas:" :content="formataEmpresas(usoDoSolo.empresasFornecedoras)" />
    </el-col>
  </div>

</template>

<style lang="scss" scoped>
  @import './style.scss'
</style>



// WEBPACK FOOTER //
// src/components(new)/UI/Modals/VisualizacaoCadastro/Cadastro/UsoDoSolo/UsoDoSolo.vue